import { Button, Typography } from '@mui/material'

export const getDateForTable = (date?: string) =>
  date && (
    <>
      <Typography variant="body2">{date.split('/')[0]}</Typography>
      <Typography variant="caption">{date.split('/')[1]}</Typography>
    </>
  )

export const getButtonText = (
  content: React.ReactNode | string,
  handleClick: () => void,
) => {
  return (
    <Button
      sx={{ textAlign: 'left', textTransform: 'none' }}
      className="link white"
      onClick={handleClick}
    >
      {content}
    </Button>
  )
}
